import Cadastro from "Components/Cadastro";
import { BrowserRouter, Route, Routes } from "react-router-dom";
function sanitizeInput(input) {
    if (!input) return '';
  
    // Permitir letras, números, '/', '+', '=' e '_', que são comuns em URLs codificadas em Base64
    let sanitizedInput = input.replace(/[^a-zA-Z0-9+/=_-]/g, '');
  
    // Remover palavras-chave SQL: SELECT, INSERT, UPDATE, DELETE
    const forbiddenWords = ['SELECT', 'INSERT', 'UPDATE', 'DELETE'];
    
    forbiddenWords.forEach(word => {
      const regex = new RegExp(word, 'gi'); // 'g' para global, 'i' para ignorar caixa
      sanitizedInput = sanitizedInput.replace(regex, '');
    });
  
    return sanitizedInput;
}

function AppRoutes(){
    const queryParams = new URLSearchParams(window.location.search);
    let token = sanitizeInput(queryParams.get('id'));
    let form = sanitizeInput(queryParams.get('form'));
    let referencia = sanitizeInput(queryParams.get('ref'));
    let md = sanitizeInput(queryParams.get('md'));
    let codigo = sanitizeInput(queryParams.get('codigo'));
    
    if(undefined == token || null == token || token == ""){
        token =  sessionStorage.getItem('token');
        form =  sessionStorage.getItem('form');
        referencia =  sessionStorage.getItem('referencia');
        md =  sessionStorage.getItem('md');
        codigo =  sessionStorage.getItem('codigo');
    }
  
    if(undefined != token && null != token && token !=""){
        sessionStorage.setItem('token',token);
        sessionStorage.setItem('form', form);
        sessionStorage.setItem('referencia', referencia);
        sessionStorage.setItem('md', md);
        sessionStorage.setItem('codigo', codigo);

    }

    if(undefined == token || null == token){
        token = "";
    }

    if(undefined == form || null == form){
        form = "";
    }

    if(undefined == referencia || null == referencia){
        referencia = "";
    }

    if(undefined == codigo || null == codigo){
        codigo = "";
    }

    if(undefined == token || null == token || token == "" || undefined == form || null == form || form == "" || undefined == referencia || null == referencia || referencia == ""){
        return (
            <div><br />
                <center>Link Inválido, entre em contato com a equipe técnica e informe o erro 0001</center>
            </div>  
        );  
    }
    
   
    return (
        <>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Cadastro />}/>
            </Routes>
        </BrowserRouter>
        <div className="versao" id="versao">Versão 1.0.0</div>
        </>
    )
}

export default AppRoutes;